module.exports = __webpack_public_path__ + "img/LEGAL-GG.978dff00.svg";